import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { CenteredLoader } from 'clipsal-cortex-ui/src/components/CenteredLoader';

import { useReduxDispatch } from '../../app/store';
import { InternetConnectionRecoveryPage } from '../../common/components/InternetConnectionRecoveryPage';
import { consumePendingPostLoginRedirect } from '../../common/post-login-redirect';
import { getSites, selectSites } from '../sites/sitesSlice';
import { selectUser } from '../user/userSlice';
import { selectSite } from './siteSlice';

export function SiteRedirect() {
  const dispatch = useReduxDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isRecoveryRetrying, setIsRecoveryRetrying] = useState(false);
  const { site_id: siteId } = useSelector(selectSite);
  const { sites, status } = useSelector(selectSites);
  const { isLoggedIn } = useSelector(selectUser);

  useEffect(() => {
    if (isLoggedIn) {
      if (status === 'idle') {
        dispatch(getSites({ pageSize: 2, offset: 0 }));
        return;
      }

      if (status !== 'succeeded') {
        return;
      }

      const pendingRedirect = consumePendingPostLoginRedirect();
      if (pendingRedirect) {
        navigate(pendingRedirect, { replace: true });
        return;
      }

      if (siteId) {
        // If we have a site ID from the store, we can navigate directly to that site
        navigate(`/sites/${siteId}/home`, { replace: true });
      } else if (sites.length === 1) {
        navigate(`/sites/${sites[0].site_id}/home`, { replace: true });
      } else if (!sites.length) {
        navigate('/sites/create', { replace: true });
      } else {
        navigate('/sites', { replace: true });
      }
    } else {
      navigate('/login', { replace: true });
    }
    return;
  }, [dispatch, isLoggedIn, navigate, siteId, sites, status]);

  async function handleRetry() {
    await dispatch(getSites({ pageSize: 2, offset: 0 }));
  }

  if (isLoggedIn && (status === 'failed' || isRecoveryRetrying)) {
    return <InternetConnectionRecoveryPage onRetry={handleRetry} onRetryingChange={setIsRecoveryRetrying} />;
  }

  if (isLoggedIn && status !== 'succeeded') {
    return <CenteredLoader text={`${t('Common.loading')}...`} />;
  }

  return null;
}
